"use strict";

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _t$partial;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TFranOrgBody = exports.TUserType = exports.TStoreId = exports.TStoreEmailCategorizations = exports.TStoreEmails = exports.UserType = void 0;

var t = __importStar(require("io-ts"));

var mapping_1 = require("../utils/mapping");

var UserType;

(function (UserType) {
  UserType["DirOfOperations"] = "DirOfOperations";
  UserType["GeneralUserFranchisee"] = "GeneralUserFranchisee";
  UserType["MultiUnitManager"] = "MultiUnitManager";
  UserType["ReportingAdministrator"] = "ReportingAdministrator";
  UserType["ReportingOperator"] = "ReportingOperator";
  UserType["RestaurantManager"] = "RestaurantManager";
  UserType["VPOperations"] = "VPOperations";
})(UserType = exports.UserType || (exports.UserType = {}));

exports.TStoreEmails = t.string;
exports.TStoreEmailCategorizations = t.partial((_t$partial = {}, _defineProperty(_t$partial, UserType.DirOfOperations, t.array(exports.TStoreEmails)), _defineProperty(_t$partial, UserType.GeneralUserFranchisee, t.array(exports.TStoreEmails)), _defineProperty(_t$partial, UserType.MultiUnitManager, t.array(exports.TStoreEmails)), _defineProperty(_t$partial, UserType.ReportingAdministrator, t.array(exports.TStoreEmails)), _defineProperty(_t$partial, UserType.ReportingOperator, t.array(exports.TStoreEmails)), _defineProperty(_t$partial, UserType.RestaurantManager, t.array(exports.TStoreEmails)), _defineProperty(_t$partial, UserType.VPOperations, t.array(exports.TStoreEmails)), _t$partial));
exports.TStoreId = t.string;
exports.TUserType = new mapping_1.Enum(UserType);
exports.TFranOrgBody = t.record(t.string, exports.TStoreEmailCategorizations);